module.exports = __webpack_public_path__ + "static/media/Logo_Black.efd6263c.png";